/**
 * * Модель запроса на получение задач
 */
export class TasksRequestModel {
  /**ID очереди */
  QueueId!: string;
  /**Строка поиска */
  SearchValue?: string;
  /**Сколько элементов пропустить */
  Skip: number = 0;
  /**Сколько элементов получить */
  Take!: number;

  constructor(obj?: Partial<TasksRequestModel>) {
    Object.assign(this, obj);
  }
}
